export default "$ yarn add stylus stylus-loader style-loader css-loader -D\n// OR\n$ npm i stylus stylus-loader style-loader css-loader -D\n";